import request from '@/utils/request'
/**
 *
 * 选手管理
 *
 **/

// 获取列表接口
export const getPlayerList = (params: any) => {
  return request({
    url: '/player/page',
    method: 'get',
    params
  })
}
// 获取列表接口
export const getContestantList = (params: any) => {
  return request({
    url: '/contestant/page',
    method: 'get',
    params
  })
}
// 获取列表接口
export const getContestantRoundList = (params: any) => {
  return request({
    url: '/round/page',
    method: 'get',
    params
  })
}

// 获取列表接口
export const getContestantRoundDetailList = (params: any) => {
  return request({
    url: '/competition/contestant/page',
    method: 'get',
    params
  })
}

// 获取列表接口
export const getContestantRoundDetailListOne = (params: any) => {
  return request({
    url: '/competition/contestant/par/score',
    method: 'get',
    params
  })
}

// 修改---新增选手
export const updateContestantRoundDetailList = (params: any) => {
  return request({
    url: '/competition/contestant/par/score',
    method: 'put',
    data: { ...params }
  })
}

// 修改---启用禁用接口
export const enableOrDisablePlayer = (params: any) => {
  return request({
    url: `/player/status/${params.status}`,
    method: 'post',
    params: { id:params.id,type: params.type }
  })
}

// 修改---启用禁用接口
export const enableOrDisableContestantRoundDetail = (params: any) => {
  return request({
    url: `/competition/contestant/status/${params.status}`,
    method: 'post',
    params: { id:params.id,type: params.type }
  })
}

// 手动规整排名
export const updateRanking = (params: any) => {
  return request({
    url: '/player/updateRanking',
    method: 'post',
    params: { titleId:params.titleId }
  })
}

// 新增---新增选手
export const addPlayer = (params: any) => {
  return request({
    url: '/player',
    method: 'post',
    data: { ...params }
  })
}

// 新增---新增参赛选手
export const addContestant = (params: any) => {
  return request({
    url: '/contestant',
    method: 'post',
    data: { ...params }
  })
}

// 新增---新增参赛选手轮数
export const addContestantRound = (params: any) => {
  return request({
    url: '/round',
    method: 'post',
    data: { ...params }
  })
}

// 新增---新增轮次参赛选手
export const addContestantRoundDetail = (params: any) => {
  return request({
    url: '/competition/contestant',
    method: 'post',
    data: { ...params }
  })
}

// 新增---导入选手
export const importPlayer = (params: any) => {
  return request({
    url: '/player/import',
    method: 'post',
    data: { ...params }
  })
}

// 修改---新增选手
export const updatePlayer = (params: any) => {
  return request({
    url: '/player',
    method: 'put',
    data: { ...params }
  })
}

// 修改---新增参赛选手
export const updateContestant = (params: any) => {
  return request({
    url: '/contestant',
    method: 'put',
    data: { ...params }
  })
}

// 修改---新增参赛选手轮数
export const updateContestantRound = (params: any) => {
  return request({
    url: '/round',
    method: 'put',
    data: { ...params }
  })
}

// 修改---新增参赛选手轮数
export const updateContestantRoundDetail = (params: any) => {
  return request({
    url: '/competition/contestant',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口
export const queryPlayerById = (id: string | (string | null)[]) => {
  return request({
    url: `/player/${id}`,
    method: 'get'
  })
}

// 修改页面反查详情接口
export const queryContestantById = (id: string | (string | null)[]) => {
  return request({
    url: `/contestant/${id}`,
    method: 'get'
  })
}

// 设置标准杆反查详情接口
export const queryParById = (titleId: string | (string | null)[]) => {
  return request({
    url: `/competition/contestant/par/${titleId}`,
    method: 'get'
  })
}

// 设置标准杆
export const updatePar = (params: any) => {
  return request({
    url: '/competition/contestant/par',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口
export const queryContestantRoundById = (id: string | (string | null)[]) => {
  return request({
    url: `/round/${id}`,
    method: 'get'
  })
}

// 修改页面反查详情接口
export const queryContestantRoundDetailById = (id: string | (string | null)[]) => {
  return request({
    url: `/competition/contestant/${id}`,
    method: 'get'
  })
}

// 删除接口（选手列表）
export const deletePlayer = (params) => {
  return request({
    url: '/player',
    method: 'delete',
    params: { ids:params.ids}
  })
}

// 删除接口（参赛选手列表）
export const deleteContestant = (params) => {
  return request({
    url: '/contestant',
    method: 'delete',
    params: { ids:params.ids}
  })
}

// 删除接口（参赛选手列表）
export const deleteContestantRound = (params) => {
  return request({
    url: '/round',
    method: 'delete',
    params: { ids:params.ids}
  })
}

// 删除接口（参赛选手列表）
export const deleteContestantRoundDetail = (params) => {
  return request({
    url: '/competition/contestant',
    method: 'delete',
    params: { ids:params.ids}
  })
}

// 获取投票记录列表接口
export const getVotingRecordsList = (params: any) => {
  return request({
    url: '/votingRecords/page',
    method: 'get',
    params
  })
}

// 删除接口(投票记录)
export const deleteVotingRecords = (params) => {
  return request({
    url: '/votingRecords',
    method: 'delete',
    params: { ids:params.ids}
  })
}

// 获取选手票数接口
export const getVotingRecords = (params: any) => {
  return request({
    url: '/votingRecords/statistics',
    method: 'get',
    params
  })
}
